<template>
    <router-view />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters('base', {
            selectedProduct: 'selectedProduct',
            originators: 'originators',
        }),
    },
    methods: {
        ...mapActions('credito', {
            updateBaseData: 'updateBaseData',
            listStatusList: 'listStatusList',
            listManagers: 'listManagers',
            getStates: 'getStates',
        }),
    },
    async created() {
        this.getStates();
        this.listStatusList({ id_produto: this.selectedProduct.id });
        this.listManagers({ id: 13 });

        this.updateBaseData({
            selectedProduct: { ...this.selectedProduct },
            originators: this.originators,
        });
    },
};
</script>